import { filters } from '../components/drive/content/tabs/templatesTab/resumesDictionary';
import universityCodes from './universityCodes';

const { MULTI_COLUMN, IMAGES } = filters;
export const universityRestriction = {
  [universityCodes.OREGONSTATE_EDU]: {
    editor: {
      resume: {
        sections: {
          inputs: ['objective', 'image'],
          defaultSections: [
            'personalInfo',
            'education',
            'workExperience',
            'skills',
            'projects',
          ],
          removeSections: ['references'],
        },
        summary: {
          disclaimer:
            'Employers typically do not favor a summary statement. However, if you decide to include one, make sure to review the Tips in the upper right hand corner.',
        },
        education: {
          score: 'GPA',
          maxScore: 'Max GPA',
          excludeFields: ['education_from'],
          education_to: {
            placeholder: 'Date',
          },
        },
        workExperience: {
          excludeFields: ['work_experience_role_achievements'],
        },
      },
    },
    templatesPolicy: {
      colorSets: ['grey', 'white'],
      activeColorSet: 'grey',
      resume: {
        templateTypes: [MULTI_COLUMN, IMAGES],
        templateNames: [
          'Emblem',
          'Gradient',
          'Techie',
          'Inventor',
          'Simple',
          'Stellar',
          'Orion',
          'Businessmajor',
          'Agricultural',
          'Proxima',
          'Streak',
          'Falcon',
          'Vintage',
          'Functional',
        ],
        basic: {
          education: {
            layout: 1,
          },
        },
        vintage: {
          education: {
            layout: 1,
          },
        },
        businessmajor: {
          education: {
            layout: 1,
          },
        },
        geospatial: {
          education: {
            layout: 1,
          },
        },
        functional: {
          education: {
            layout: 1,
          },
        },
      },
      cover_letter: {
        templateTypes: [MULTI_COLUMN, IMAGES],
        templateNames: ['Gradient'],
      },
    },
  },
  [universityCodes.WSU_EDU]: {
    editor: {
      resume: {
        sections: {
          inputs: ['document-picture'],
        },
      },
    },
  },
  [universityCodes.SAGE_HILL_SCHOOL]: {
    editor: {
      resume: {
        sections: {
          inputs: ['image'],
          defaultSections: [
            'personalInfo',
            'education',
            'skills',
            'projects',
            'workExperience',
          ],
          removeSections: ['testScores', 'patents'],
        },
        workExperience: {
          excludeFields: ['work_experience_role_achievements'],
        },
        volunteerWork: {
          excludeFields: ['volunteer_work_cause_title'],
        },
        personalInfo: {
          disclaimer: null,
          tagline: {
            placeholder: 'Pronouns',
          },
        },
        education: {
          education_role_description: {
            placeholder: 'Coursework',
          },
          education_role_details: { placeholder: 'Degree' },
          education_degree_title: { placeholder: 'Degree' },
        },
        hobbiesAndInterests: {
          hobbies_and_interests: {
            placeholder: 'Only include unique skills',
          },
        },
        courses: {
          courses_role_details: {
            placeholder: 'Sports',
          },
          courses_course_title: {
            placeholder: 'Sports',
          },
        },
        associations: {
          associations_association_title: {
            placeholder: 'Fundamentals of Art',
          },
          associations_role_details: {
            placeholder: 'Fundamentals of Art',
          },
        },
      },
    },
    templatesPolicy: {
      resume: {
        templateTypes: [MULTI_COLUMN],
      },
      cover_letter: {
        templateTypes: [MULTI_COLUMN],
      },
    },
    tetra: {
      resume: {
        sections: {
          exclude: ['courses', 'associations'],
        },
      },
    },
    services: {
      restriction: {
        iris: {
          downloadAll: true,
        },
      },
    },
  },
  [universityCodes.EWU_EDU]: {
    templatesPolicy: {
      resume: {
        templateNames: [
          'Exemplary',
          'Emblem',
          'Inventor',
          'Nineties',
          'Proxima',
        ],
      },
    },
  },
  [universityCodes.NWMISSOURI_EDU]: {
    templatesPolicy: {
      resume: {
        recommendedTemplates: ['Basic', 'Simple', 'Vintage'],
      },
      cover_letter: {
        recommendedTemplates: ['Basic', 'Simple', 'Vintage'],
      },
    },
  },
  [universityCodes.PURDUE_EDU]: {
    templatesPolicy: {
      resume: {
        templateTypes: [MULTI_COLUMN],
      },
      cover_letter: {
        templateTypes: [MULTI_COLUMN],
      },
    },
  },
  [universityCodes.APSU_EDU]: {
    templatesPolicy: {
      resume: {
        templateTypes: [MULTI_COLUMN],
      },
      cover_letter: {
        templateTypes: [MULTI_COLUMN],
      },
    },
  },
};

export const universityFeatureRestrictionFilter = (
  items,
  formatType,
  universityPlan,
) => {
  if (
    universityRestriction[universityPlan?.code]?.templatesPolicy?.[
      formatType.split(' ').join('_').toLowerCase()
    ]?.templateTypes ||
    universityRestriction[universityPlan?.code]?.templatesPolicy?.[
      formatType.split(' ').join('_').toLowerCase()
    ]?.templateNames
  )
    return (
      !universityRestriction[universityPlan?.code]?.templatesPolicy?.[
        formatType.split(' ').join('_').toLowerCase()
      ]?.templateTypes?.some((templateType) =>
        items?.filterType?.includes(templateType),
      ) &&
      !universityRestriction[universityPlan?.code]?.templatesPolicy?.[
        formatType.split(' ').join('_').toLowerCase()
      ]?.templateNames?.some((templateName) => items?.name === templateName)
    );
  return true;
};

export const universityEditorSectionRestriction = (
  section,
  formatType,
  universityPlan,
) => {
  if (
    universityRestriction[universityPlan?.code]?.editor?.[
      formatType.split(' ').join('_').toLowerCase()
    ]?.sections?.inputs
  ) {
    return !universityRestriction[universityPlan?.code]?.editor?.[
      formatType.split(' ').join('_').toLowerCase()
    ]?.sections?.inputs?.includes(section);
  }
  return true;
};

export const getUniversityServicesRestrictions = (universityPlan) => {
  const { code } = universityPlan || {};
  if (universityRestriction[code]?.services) {
    return universityRestriction[code]?.services;
  }
  return null;
};
export const universityEditorSectionRestrictionData = (
  formatType,
  universityPlan,
) => {
  return universityRestriction[universityPlan?.code][
    formatType.split(' ').join('_').toLowerCase()
  ]?.editor;
};
